import { render, staticRenderFns } from "./lid-data-staff.vue?vue&type=template&id=70caba64&"
import script from "./lid-data-staff.vue?vue&type=script&lang=js&"
export * from "./lid-data-staff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports